$(document).on('click', '.quick-view', function(){  
  var objj = $(this), var_id = objj.data('variant'), data= 'quantity='+ 1 + '&id=' +var_id;
  objj.children('.CV_bundle_btn').addClass('hide');
  objj.children('.loaderInit').removeClass('hide');
  
  if(var_id){
    $.ajax({
      url:'/cart/add.js',
      type:'POST',
      dataType: 'json',
      data: data,
      success: function(response){
        reloadCart();
        objj.children('.CV_bundle_btn').removeClass('hide');
        objj.children('.loaderInit').addClass('hide');
      }
    });
  }
});
$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});